import CompanyGroup, { Company } from 'models/Profile/CompanyGroups';
import formatIdentifier from 'utils/formatIdentifier';
import { getPreferredLanguage } from 'utils/preferredLanguage';

export function filter(filterConditions : string | undefined, company : Company) : boolean {
  const language = getPreferredLanguage();

  if(filterConditions === undefined) return true;
  if(filterConditions === '') return true;

  console.log(filterConditions.replace('.', '').replace('/', '').replace('-', ''));
  return compareString(company.name, filterConditions)
        || compareString(company.identifier, filterConditions)
        || compareString(formatIdentifier(company.identifier, language), filterConditions);
}

function compareString(value : string, condition : string) : boolean {
  if(!value) return false;
  if(!condition) return false;

  return value.toLowerCase().includes(condition.toLowerCase());
}

export function sortCompanies(a: Company, b: Company): number {
  return compareValues(a.name, b.name);
}

export function sortCompaniesGroup(a: CompanyGroup, b: CompanyGroup): number {
  return compareValues(a.groupName, b.groupName);
}

function compareValues(previous : string, actual : string) : number {
  if(previous > actual)
    return 1;

  return previous < actual ? -1 : 0;
}